/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { useHistory, NavLink } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import 'react-phone-input-2/lib/style.css'
import { signup, socialMediaLogin } from '../../actions/auth'
import GoogleLogin from 'react-google-login'
import SocialButton from './SocialButton'
import { ToastContainer } from 'react-toastify'
import SweetAlert from '../../components/Alerts/SweetAlert'
import axios from 'axios'
import Config from '../../config/Config';

const Signup = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [agree, setAgree] = useState(false)

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  })

  const [formDataError, setFormDataError] = useState({
    email: '',
    password: '',
  })

  const errorMessage = {
    first_name: {
      required: 'First name is required',
    },
    last_name: {
      required: 'Last name is required',
    },
    phone_number: {
      required: 'Phone number is required',
    },
    email: {
      required: 'Email is required',
      invalid: 'Invalid e-mail address',
    },
    password: {
      required: 'Password is required',
      invalid: 'Password must at least 8 characters',
    },
  }
  const validateInput = (value, stateName) => {
    if (!value) {
      setFormDataError((formDataError) => ({
        ...formDataError,
        [stateName]: errorMessage[stateName].required,
      }))
      return false
    }

    switch (stateName) {
      case 'email':
        const emailValid = validateEmail(value)
        if (!emailValid) {
          setFormDataError((formDataError) => ({
            ...formDataError,
            [stateName]: errorMessage[stateName].invalid,
          }))
          return false
        } else {
          setFormDataError((formDataError) => ({
            ...formDataError,
            [stateName]: '',
          }))
          return true
        }
      case 'password':
        const passwordValid = validatePassword(value)
        if (!passwordValid) {
          setFormDataError((formDataError) => ({
            ...formDataError,
            [stateName]: errorMessage[stateName].invalid,
          }))
          return false
        } else {
          setFormDataError((formDataError) => ({
            ...formDataError,
            [stateName]: '',
          }))
          return true
        }
      default:
        setFormDataError((formDataError) => ({
          ...formDataError,
          [stateName]: '',
        }))
        return true
    }
  }

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  }

  const validatePassword = (password) => {
    return password.length >= 8
  }

  const onChange = (value, stateName) => {
    validateInput(value, stateName)
    setFormData({ ...formData, [stateName]: value })
  }

  const checkboxHandler = () => {
    // if agree === true, it will be set to false
    // if agree === false, it will be set to true
    setAgree(!agree)
    // Don't miss the exclamation mark
  }

  const handleSignup = async (e) => {
    e.preventDefault()
    const result = Object.keys(formData).map((key) => {
      return validateInput(formData[key], key)
    })

    const isInvalid = result.filter((r) => !r).length > 0

    if (isInvalid) {
      return
    }

    let resp = await dispatch(signup(formData.email, formData.password))

    if (resp.type === 'AUTH_SIGNUP_SUCCESS') {
      // SweetAlert.success(t('signup_success'), t)
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
      axios.defaults.withCredentials = true
      axios
        .post(Config.REACT_APP_SERVER_URL + '/login', formData)
        .then(() => {
          history.push('/email-verify-guide')
        })
    }

    if (resp.type === 'AUTH_SIGNUP_FAILURE') {
      if (resp.payload.errors.email) {
        SweetAlert.error(resp.payload.errors.email[0])
      } else {
        SweetAlert.error('Sign up Failed')
      }
    }
  }
  const responseGoogle = async (response) => {
    console.log('responseGoogle', response?.tokenObj)
    console.log('responseGoogle', response)
    // if (response?.error === "popup_closed_by_user") {
    let resp = await dispatch(
        socialMediaLogin(response?.tokenObj?.access_token, 'google', 1),
    )
    if (resp.type === 'AUTH_SOCIAL_LOGIN_SUCCESS') {
      //SweetAlert.success('You are logged in!')
      history.push('/signup-step')
    } else if (resp.type === 'AUTH_SOCIAL_LOGIN_FAILURE') {
      if (resp.payload.message) {
        SweetAlert.error(resp.payload.message)
      } else {
        SweetAlert.error('These credentials do not match our records.')
      }
    }
    // }
  }
  const responseFacebook = async (response) => {
    console.log('responseFacebook', response, response?._token?.accessToken)
    let resp = await dispatch(
        socialMediaLogin(response?._token?.accessToken, 'facebook', 1),
    )
    if (resp.type === 'AUTH_SOCIAL_LOGIN_SUCCESS') {
      //SweetAlert.success('You are logged in!')
      history.push('/signup-step')
    } else if (resp.type === 'AUTH_SOCIAL_LOGIN_FAILURE') {
      if (resp.payload.message) {
        SweetAlert.error(resp.payload.message)
      } else {
        SweetAlert.error('These credentials do not match our records.')
      }
    }
  }

  return (
    <>
       <section className="signup-login">
        <div className="container-fluid">
          <ToastContainer autoClose={8000} />
          <div className="row">
            <div className="col-md-4 col-lg-6 signup-login-bg"></div>
            <div className="col-md-8 col-lg-6">
              <div className="d-flex align-items-center py-5 signup-login-content">
                <div className="container">
                  <div className="row">
                    <div className="col-md-10 col-xl-7 mx-auto">
                      <h4>Sign up for free</h4>
                      <span className="d-block font-weight-medium mb-4">
                      Enjoy up to 70% or more savings on your favorite brands
                      </span>

                      <GoogleLogin
                        clientId="1085184020113-6p2723e837phg393nk304mnb22l4drt1.apps.googleusercontent.com"
                        // clientId="147101037577-tieccfca0g44cckj19242u40hvg9l5p7.apps.googleusercontent.com"
                        render={(renderProps) => (
                          <button
                            className="btn p-0 btn-lg btn-google btn-block mb-2"
                            onClick={renderProps.onClick}
                            disabled={renderProps.disabled}
                          >
                            <a
                              href=""
                              className="btn btn-login btn-lg btn-google btn-block"
                            >
                              <img src="./img/google_icon.png" alt="" />
                              <span>Sign up with Google</span>
                            </a>
                          </button>
                        )}
                        buttonText="Login"
                        onSuccess={responseGoogle}
                        // onFailure={(response) =>
                        //   console.log("onFailure", response)
                        // }
                        // onFailure={responseGoogle}
                        onFailure={(res) => console.log('onFailure', res)}
                        cookiePolicy={'single_host_origin'}
                      />
                      {/* <a
                        href=""
                        className="btn btn-login btn-lg btn-google btn-block"
                      >
                        <img src="./img/google_icon.png" alt="" />
                        <span>Sign up with Google</span>
                      </a> */}
                      {/* <button className="btn btn-login btn-lg btn-facebook btn-block p-0">
                        <a
                          href="#"
                          className="btn btn-login btn-lg btn-facebook btn-block"
                          onClick={() => responseFacebook()}
                        >
                          <img src="./img/facebook_icon.png" alt="" />
                          <span>Continue with Facebook</span>
                        </a>
                      </button> */}
                      {/* <FacebookLogin
                        appId="432051825396412"
                        // autoLoad={true}
                        // fields="name,email,picture"
                        callback={responseFacebook}
                        onFailure={(res) => console.log("onFailure", res)}
                        className="btn btn-login btn-lg btn-facebook btn-block"
                        icon={
                          <a
                            href=""
                            className="btn btn-login btn-lg btn-facebook btn-block"
                          >
                            <img src="./img/facebook_icon.png" alt="" />
                            <span>Continue with Facebook</span>
                          </a>
                        }
                        textButton=""
                      /> */}
                      <SocialButton
                        provider="facebook"
                        appId="980008419348109"
                        onLoginSuccess={responseFacebook}
                        onLoginFailure={(res) =>
                          console.log('onLoginFailure', res)
                        }
                      ></SocialButton>
                      {/* <a
                        href=""
                        className="btn btn-login btn-lg btn-facebook btn-block"
                        onClick={() => responseFacebook()}
                      >
                        <img src="./img/facebook_icon.png" alt="" />
                        <span>Continue with Facebook</span>
                      </a> */}
                      {/* }
                        textButton=""
                      /> */}
                      {/* <a
                        href=""
                        className="btn btn-login btn-lg btn-facebook btn-block"
                      >
                        <img src="./img/facebook_icon.png" alt="" />
                        <span>Continue with Facebook</span>
                      </a> */}
                      <span className="d-block font-weight-medium text-center py-7 separator">
                        Or, sign up with your email
                      </span>
                      <form onSubmit={handleSignup}>
                        <div className="pb-3">
                          <div className="form-group">
                            <label for="emailAddress">Email address</label>
                            <input
                              type="email"
                              className="form-control"
                              id="email"
                              name="email"
                              value={formData.email}
                              onChange={(e) =>
                                onChange(e.target.value, 'email')
                              }
                            />
                            {formDataError.email && (
                              <p className="error-msg">{formDataError.email}</p>
                            )}
                          </div>
                          <div className="form-group">
                            <label for="password">Password</label>
                            <input
                              type="password"
                              className="form-control"
                              id="password"
                              name="password"
                              value={formData.password}
                              onChange={(e) =>
                                onChange(e.target.value, 'password')
                              }
                            />
                            {formDataError.password && (
                              <p className="error-msg">
                                {formDataError.password}
                              </p>
                            )}
                          </div>
                          <div className="form-group form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="agree"
                              onChange={() => checkboxHandler()}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="agree"
                            >
                              I agree to <NavLink to="/terms" target="_blank">service terms</NavLink> and <NavLink
                                to="/privacy" target="_blank">privacy policy</NavLink>.
                            </label>
                          </div>
                          <button
                            disabled={!agree}
                            className="btn btn-lg btn-secondary btn-block"
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                      <span className="d-block log-in">
                        <strong className="mr-1">
                          Already have an account?
                        </strong>{' '}
                        <NavLink to="/login">Sign in now</NavLink>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Signup
